import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M12.17,22.17A12.21,12.21,0,0,1,7,12,12.23,12.23,0,0,1,12.17,1.83,1,1,0,0,0,12.56.69a1,1,0,0,0-1-.69,12,12,0,0,0,0,24h0a1,1,0,0,0,1-.69A1,1,0,0,0,12.17,22.17Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M22.51,18C20.11,18,19,16.84,19,14.5h0a.53.53,0,0,0-.5-.5.5.5,0,0,0-.5.5c0,2.35-1.12,3.47-3.51,3.5a.5.5,0,0,0,0,1h0C16.9,19,18,20.08,18,22.5a.51.51,0,0,0,.49.5h0a.5.5,0,0,0,.5-.47c.12-2.41,1.22-3.53,3.47-3.53h0a.5.5,0,0,0,.5-.49A.51.51,0,0,0,22.51,18Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M16,11h0a.5.5,0,0,0,0-1c-1.39,0-2-.65-2-2a.51.51,0,0,0-.5-.5A.5.5,0,0,0,13,8h0c0,1.36-.62,2-2,2a.5.5,0,0,0,0,1h0c1.38,0,2,.6,2,2a.51.51,0,0,0,.49.5h0A.5.5,0,0,0,14,13C14.07,11.62,14.68,11,16,11Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M23.51,4C21.77,4,21,3.19,21,1.5a.5.5,0,0,0-.5-.5h0a.5.5,0,0,0-.5.5C20,3.21,19.22,4,17.49,4a.5.5,0,0,0,0,1h0C19.22,5,20,5.77,20,7.5a.51.51,0,0,0,.49.5h0a.5.5,0,0,0,.5-.48C21.09,5.78,21.85,5,23.48,5h0a.5.5,0,0,0,.5-.49A.51.51,0,0,0,23.51,4Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }